import ReactGA from "react-ga4";

export const initGA = (id: string, notAnonymize: boolean) => {
  ReactGA.initialize([{trackingId: id, gaOptions: {anonymizeIp: !notAnonymize, allowAdFeatures: false, allowAdPersonalizationSignals: false}}]);
};
